__turbopack_context__.v({
  "canvas": "gDkTQq_canvas",
});
